import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cf49c1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "merchant_alert",
  ref: "merchantAlert",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog",
  style: {"max-width":"700px !important"}
}
const _hoisted_3 = { class: "modal-content p-2" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "d-flex flex-stack flex-grow-1 pt-3" }
const _hoisted_6 = { class: "notice d-flex bg-light-warning rounded w-100 border-warning border border-dashed p-4" }
const _hoisted_7 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder fs-5" }, "Please Note!"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-gray-600" }, [
    /*#__PURE__*/_createTextVNode(" A one-time secure connection will be attempted to "),
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Bank Of America")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-body\" data-v-5cf49c1a><div class=\"scroll-y me-n7 pe-7\" id=\"kt_modal_create_api_key_scroll\" data-kt-scroll=\"true\" data-kt-scroll-activate=\"{default: false, lg: true}\" data-kt-scroll-max-height=\"auto\" data-kt-scroll-dependencies=\"#kt_modal_create_api_key_header\" data-kt-scroll-wrappers=\"#kt_modal_create_api_key_scroll\" data-kt-scroll-offset=\"300px\" data-v-5cf49c1a><div class=\"card card-dashed h-xl-100 flex-row flex-stack flex-wrap p-4 mb-3\" data-v-5cf49c1a><div class=\"d-flex flex-column py-2\" data-v-5cf49c1a><div class=\"d-flex align-items-center fs-4 fw-bold mb-5\" data-v-5cf49c1a> Marcus Morris <span class=\"badge badge-light-success fs-7 ms-2\" data-v-5cf49c1a>Primary</span></div><div class=\"d-flex align-items-center\" data-v-5cf49c1a><img src=\"/media/svg/card-logos/visa.svg\" alt=\"\" class=\"me-4\" data-v-5cf49c1a><div data-v-5cf49c1a><div class=\"fs-6 fw-bold\" data-v-5cf49c1a>444110 **** 1679</div><div class=\"fs-8 fw-semibold text-gray-400\" data-v-5cf49c1a> 2023/01/04 00:23:33 </div></div></div></div><div class=\"d-flex align-items-bottom\" data-v-5cf49c1a><div data-v-5cf49c1a><div class=\"fs-4 fw-bold text-end\" data-v-5cf49c1a><span class=\"fs-3 fw-bold\" data-v-5cf49c1a>$</span>44.59 </div><div class=\"fs-6 fw-semibold text-gray-400\" data-v-5cf49c1a> https://www.merchantwebsite.com </div></div></div></div></div></div>", 1)
const _hoisted_10 = { class: "modal-body scroll-y pt-0 pb-15" }
const _hoisted_11 = { class: "mw-lg-600px mx-auto" }
const _hoisted_12 = { class: "mb-10" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fs-7 fw-bold text-gray-800" }, " Issuer Authentication Secret ", -1))
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = {
  ref: "inputRef",
  id: "kt_share_earn_link_input",
  type: "text",
  class: "form-control form-control-solid me-3 flex-grow-1 fs-7",
  name: "search",
  value: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9"
}
const _hoisted_16 = {
  ref: "copyButtonRef",
  id: "kt_share_earn_link_copy_button",
  class: "btn btn-sm btn-light-primary fw-bolder flex-shrink-0 fs-8 fw-bold",
  "data-clipboard-target": "#kt_share_earn_link_input"
}
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center mt-10\" data-v-5cf49c1a><div class=\"flex-grow-1\" data-v-5cf49c1a><span class=\"fs-7 fw-bold text-gray-800 d-block\" data-v-5cf49c1a>Refund Payment Link</span><span class=\"fs-8 fw-bold text-gray-400\" data-v-5cf49c1a>Include a refund url in the notification messaage</span></div><label class=\"form-check form-switch form-check-custom form-check-solid\" data-v-5cf49c1a><input class=\"form-check-input\" type=\"checkbox\" value=\"1\" data-v-5cf49c1a></label></div><div class=\"d-flex align-items-center mt-5\" data-v-5cf49c1a><div class=\"flex-grow-1\" data-v-5cf49c1a><span class=\"fs7 fw-bold text-gray-800 d-block\" data-v-5cf49c1a>Purchase Details Link</span><span class=\"fs-8 fw-bold text-gray-400\" data-v-5cf49c1a>Include the Purchase Details in the notification messaage</span></div><label class=\"form-check form-switch form-check-custom form-check-solid h-20\" data-v-5cf49c1a><input class=\"form-check-input\" type=\"checkbox\" value=\"2\" data-v-5cf49c1a></label></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
              ]),
              _hoisted_8
            ])
          ])
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("input", _hoisted_15, null, 512),
                _createElementVNode("button", _hoisted_16, " Send Alert ", 512)
              ])
            ]),
            _hoisted_17
          ])
        ])
      ])
    ])
  ], 512))
}